"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var PALETTE_NAMES = Object.freeze({
  GRAYSCALE: "GRAYSCALE",
  GRAYSCALE_INVERTED: "GRAYSCALE_INVERTED",
  BLUERED: "BLUERED",
  HIGHCONTRAST: "HIGHCONTRAST",
  HOTMETAL: "HOTMETAL",
  IRONBOW: "IRONBOW",
  AMBER: "AMBER",
  AMBER_INVERTED: "AMBER_INVERTED",
  RAINBOW: "RAINBOW",
  RAINBOW900: "RAINBOW900",
  GLOWBOW: "GLOWBOW",
  PHANTOM_BLRED: "PHANTOM_BLRED",
  PHANTOM_VBW: "PHANTOM_VBW",
  PHANTOM_VVARIO: "PHANTOM_VVARIO",
  PHANTOM_RAINBOW: "PHANTOM_RAINBOW",
  PHANTOM_STUF10: "PHANTOM_STUF10",
  PHANTOM_BKRED: "PHANTOM_BKRED",
  PHANTOM_FIRE: "PHANTOM_FIRE",
  PHANTOM_MENTHOL: "PHANTOM_MENTHOL",
  PHANTOM_SEPIA: "PHANTOM_SEPIA",
  PHANTOM_SWVARIO: "PHANTOM_SWVARIO",
  MUSE_GRAYSCALE: "MUSE_GRAYSCALE",
  MUSE_HOTMETAL: "MUSE_HOTMETAL",
  MUSE_IRONBOW: "MUSE_IRONBOW",
  PHANTOM_VIRON: "PHANTOM_VIRON"
});
var _default = exports.default = PALETTE_NAMES;